import React, { createContext } from "react"
import { GetAppPreflightDataQuery } from "../graphql/generated/graphql"

export interface RedirectData {
  destination?: string
  data: Record<string, any>
}

export interface RedirectContextType {
  _data: RedirectData
  _setData: React.Dispatch<React.SetStateAction<RedirectData>>
  setData: (data: string | any, destination?: string) => void
  getData: (destination?: string) => RedirectData
}

export const RedirectContext = createContext<RedirectContextType>({
  _data: { data: {} },
  _setData: () => {
    return
  },
  setData: () => {
    return
  },
  getData: () => {
    return { data: {} }
  },
})

export enum CookiesEnum {
  Token = "_token",
}
export type PreflightData = {
  data: GetAppPreflightDataQuery
}

export interface AuthContextType {
  preflightData: any
  preflightDataLoaded: boolean
  referredByUser: string
  setReferredByUser: (referredByUser: string) => void
  token: string | undefined
  setToken: (token: string) => void
  setPreflightData: (preflightData: any) => void
  setPreflightDataLoaded: (preflightDataLoaded: any) => void
  setPreflightMutationCalled: (preflightMutationCalled: any) => void
  setUserId: (userId: string | undefined) => void
  userId: string | undefined
  triggerRerender: () => void
  cameraEnabled: boolean
  micEnabled: boolean
  setCameraEnabled: React.Dispatch<React.SetStateAction<boolean>>
  setMicEnabled: React.Dispatch<React.SetStateAction<boolean>>
  closeModal: boolean
  setCloseModal: React.Dispatch<React.SetStateAction<boolean>>
  pageTheme: string | undefined
}

export const initAuthValues: AuthContextType = {
  micEnabled: true,
  cameraEnabled: true,
  triggerRerender: () => {
    return
  },
  setCameraEnabled: () => {
    return
  },
  setMicEnabled: () => {
    return
  },
  userId: undefined,
  closeModal: false,
  setCloseModal: () => {
    return
  },
  preflightData: undefined,
  preflightDataLoaded: false,
  token: "",
  referredByUser: "",
  setReferredByUser: () => {
    return
  },
  setToken: () => {
    return
  },
  setPreflightData: () => {
    return
  },
  setPreflightDataLoaded: () => {
    return
  },
  setPreflightMutationCalled: () => {
    return
  },
  setUserId: () => {
    return
  },
  pageTheme: undefined,
}
export const AuthContext = createContext<AuthContextType>(initAuthValues)

export interface Web3ContextType {
  networkId: number
  userWallet: string
  setUserWallet: (userWallet: string) => void
  web3: any
  setWeb3: (web3: any) => void
}
export const initWeb3Values: Web3ContextType = {
  userWallet: "",
  networkId: 8001,
  web3: {},
  setWeb3: () => {
    return
  },
  setUserWallet: () => {
    return
  },
}

export const Web3Context = createContext<Web3ContextType>(initWeb3Values)

export const DomainPath = () => {
  let domain = "https://joinbonsai.co"
  if (process.env.NEXT_PUBLIC_ENV === "development") {
    domain = "https://bonsailocal.com"
  } else if (process.env.NEXT_PUBLIC_ENV === "staging") {
    domain = "https://staging.joinbonsai.co"
  } else if (process.env.NEXT_PUBLIC_ENV === "playground") {
    domain = "https://playground.joinbonsai.co"
  }
  return domain
}

export const ShareToTwitter = (shareUrl: string) => {
  return `https://twitter.com/intent/tweet?url=${shareUrl}`
}
